export const LOAD_WATCHLIST = "LOAD_WATCHLIST";
export const ADD_TO_WATCHLIST = "ADD_TO_WATCHLIST";
export const UPDATE_WATCHLIST_ITEM = "UPDATE_WATCHLIST_ITEM";
export const REMOVE_FROM_WATCHLIST = "REMOVE_FROM_WATCHLIST";
export const BULK_UPDATE_WATCHLIST = "BULK_UPDATE_WATCHLIST";
